var render, staticRenderFns
import script from "./salesGroup.vue?vue&type=script&lang=js&"
export * from "./salesGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb4e2ea",
  null
  
)

export default component.exports